/* eslint-disable
    no-lonely-if,
    no-shadow,
    no-unused-vars,
    one-var,
    prefer-const,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import Editor from 'notebook/mediocre/core-ui/Editor';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import WithSpreadsheetEvaluationUserMixin from 'notebook/tables/spreadsheets/WithSpreadsheetEvaluationUserMixin';
import {StepLevel, EditorKey} from 'notebook/protocols/StepConstants';
import ImageEditableClass from 'notebook/protocols/editor/ImageEditable';
import STEPS_EDITOR_PLUGINS from 'notebook/protocols/editor/StepsEditorPlugins';
import ProtocolStoreTransforms from 'notebook/protocols/ProtocolStoreTransforms';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';

const TABBABLE_LEVELS = [StepLevel.HEADER, StepLevel.STEP, StepLevel.DESC];

function levelTab(level) {
  switch (level) {
    case StepLevel.HEADER:
      return StepLevel.STEP;
    case StepLevel.STEP:
      return StepLevel.DESC;
    default:
      return level;
  }
}

function levelUntab(level) {
  switch (level) {
    case StepLevel.STEP:
      return StepLevel.HEADER;
    case StepLevel.DESC:
      return StepLevel.STEP;
    default:
      return level;
  }
}

const makeStep = ProtocolStoreTransforms.makeStep.bind(ProtocolStoreTransforms);
const makeTable = ProtocolStoreTransforms.makeTable.bind(ProtocolStoreTransforms);
const makeImage = ProtocolStoreTransforms.makeImage.bind(ProtocolStoreTransforms);
const makeTimer = ProtocolStoreTransforms.makeTimer.bind(ProtocolStoreTransforms);

const StepsEditor = Editor.createClass({
  mixins: [WithSpreadsheetEvaluationUserMixin, PureRenderMixin],

  propTypes: {
    fileId: PropTypes.string.isRequired,
    protocol: PropTypes.object.isRequired,
    storeState: PropTypes.func.isRequired,
    restoreState: PropTypes.func.isRequired,
    jumpTo: PropTypes.func.isRequired,
    updateProtocol: PropTypes.func, // omitted if locked
    spellCheck: PropTypes.bool.isRequired,
    isLockedWithEditWarn: PropTypes.func.isRequired,
  },

  plugins: STEPS_EDITOR_PLUGINS,
  displayName: 'StepsEditor',

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({highlightIndex: nextProps.highlightIndex, insertIndex: nextProps.insertIndex});
  },

  _getRoot() {
    return this.props.rootRef.current;
  },

  getComputedTables(root) {
    return null;
  },

  getValidationErrorSnapshot() {
    return {};
  },

  isVirtualizationSupported() {
    return false;
  },

  // Required by Editor
  editorName() {
    return 'steps';
  },
  getDocumentVersionCid() {
    return this.props.protocol.cid;
  },
  multiSelectKey() {
    return 'steps';
  },
  defaultInsertType: StepLevel.HEADER,
  textType: StepLevel.STEP,
  tableType: StepLevel.TABLE,
  headerType: StepLevel.HEADER,
  descType: StepLevel.DESC,
  getExtraTypingPerfMetadata() {
    const items = this.props.getItems(this.props.getRoot());
    const itemCounts = _.countBy(items, (item) => `num_${item.level.toLowerCase()}`);
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(
      {
        num_items: items.length,
      },
      itemCounts
    );
  },
  makeEditorProps(props) {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(this.makeEditorPropsBase(props), {
      spellCheck: props.spellCheck,
    });
  },

  isLockedWithEditWarn() {
    return this.props.isLockedWithEditWarn();
  },

  // Steps don't have a headerType property; instead they use {type: StepLevel.HEADER}
  getHeaderType(item) {
    return null;
  },
  canItemHaveHeader(item) {
    return false;
  },
  headerTypeAccessor() {
    throw new Error('Unexpected call to headerTypeAccessor.');
  },
  getFormats(item) {
    return item.formats;
  },
  makeItem(level) {
    switch (level) {
      case StepLevel.HEADER:
      case StepLevel.STEP:
      case StepLevel.DESC:
        return makeStep('', formatters.defaultFormats(), level);
      case StepLevel.TIMER:
        return makeTimer();
      case StepLevel.IMAGE:
        return makeImage();
      case StepLevel.TABLE:
        return makeTable(null, null, 2, 2); // name will be properly set by caller.
      default:
        throw new Error(`Unexpected level: ${level}`);
    }
  },

  replaceItems() {
    return this.replaceItemsDefault(...arguments);
  },
  deleteRangeHandler() {
    return this.deleteRangeHandlerDefault(...arguments);
  },
  isItemTextual(item) {
    return this.getPluginByItem(item).textual;
  },
  itemHasText(item) {
    return this.isItemTextual(item);
  },
  insertItemHandler(index, type = null) {
    if (type == null) {
      type = this.defaultItemType();
    }
    this.insertDefaultableItemHandler(index, type);
  },

  parseItemsFromFile(file) {
    if (!Array.from(ImageEditableClass.SUPPORTED_TYPES).includes(file.type)) {
      return Promise.resolve({});
    }
    const deferred = ImageEditableClass.uploadFile(file).then((url) => {
      const imageItem = reactUpdate(makeImage(), {
        image: {$merge: {url}},
      });
      return {items: [imageItem]};
    });
    return Promise.resolve(deferred);
  },

  render() {
    return (
      <div className="stepsEditor mediocre" ref={this.props.rootRef}>
        {this.shouldRenderMaximizedTable() ? this.renderFocusedTable() : this.renderEditor()}
      </div>
    );
  },

  defaultItemType() {
    return StepLevel.STEP;
  },

  // Convenience methods
  getSteps() {
    return this.props.getItems(this.props.getRoot());
  },

  setSteps(newSteps) {
    const newProtocol = reactUpdate(this.props.getRoot(), this.props.itemsAccessor({$set: newSteps}));
    this.props.updateRoot(newProtocol);
  },

  // Required by textual plugins
  stepMergeUpHandler(index, e) {
    let newStep, newSteps;
    const {anchor} = e;
    const steps = this.getSteps();

    const mergeSteps = (index) => {
      let text;
      const aboveStep = steps[index];
      const belowStep = steps[index + 1];
      if (
        Array.from(TABBABLE_LEVELS).includes(aboveStep.level) &&
        Array.from(TABBABLE_LEVELS).includes(belowStep.level)
      ) {
        // Normal merge betwen two textual steps.
        const aboveFmtText = this.getText(aboveStep);
        const belowFmtText = this.getText(belowStep);
        const cursor = aboveFmtText.text.length;
        text = aboveFmtText.text + belowFmtText.text;
        const formats = formatters.joinFormats(aboveFmtText.formats, belowFmtText.formats, cursor);
        newStep = this.withUpdatedText(aboveStep, {text, formats});
        newSteps = reactUpdate(steps, {
          $splice: [
            [index, 1, newStep],
            [index + 1, 1],
          ],
        });
        this.setSteps(newSteps);
        this.props.requestSelection({selection: {cid: newStep.cid, start: cursor, end: cursor}});
      } else if (Array.from(TABBABLE_LEVELS).includes(aboveStep.level) && !aboveStep.text.length) {
        // Empty aboveStep, belowStep is non-text so selection goes to the beginning of belowStep.
        newSteps = reactUpdate(steps, {$splice: [[index, 1]]});
        this.setSteps(newSteps);
        this.props.requestSelection(this.selectionAtStart(belowStep));
      } else if (Array.from(TABBABLE_LEVELS).includes(belowStep.level) && !belowStep.text.length) {
        // Empty belowStep, aboveStep is non-text so selection goes to the end of aboveStep
        newSteps = reactUpdate(steps, {$splice: [[index + 1, 1]]});
        this.setSteps(newSteps);
        this.props.requestSelection(this.selectionAtEnd(aboveStep));
      }
    };

    if (anchor) {
      // Merge with below, if possible.
      if (index + 1 < steps.length) {
        mergeSteps(index);
      }
    } else {
      // Merge with above, if possible.
      if (index - 1 >= 0) {
        mergeSteps(index - 1);
      } else {
        // Otherwise, untab.
        newStep = reactUpdate(steps[0], {$merge: {level: levelUntab(steps[0].level)}});
        newSteps = reactUpdate(steps, {$splice: [[0, 1, newStep]]});
        this.setSteps(newSteps);
        this.props.requestSelection({selection: {cid: steps[0].cid, start: 0, end: 0}});
      }
    }
  },

  formatHandler(index, e) {
    this.props.formatHandler(index, e);
  },

  updateTimeHandler(index, time) {
    const steps = this.getSteps();
    const newStep = reactUpdate(steps[index], {time_seconds: {$set: time}});
    const newSteps = reactUpdate(steps, {$splice: [[index, 1, newStep]]});
    this.setSteps(newSteps);
  },

  stepSplitHandler(index, e) {
    let levels;
    let {before, selected, after, cursor} = e;
    const steps = this.getSteps();
    const step = steps[index];

    let {text, formats} = this.getText(step);
    const beforeFormats = formatters.splitFormats(formats, before.length).before;
    const afterFormats = formatters.splitFormats(formats, selected.length + before.length).after;
    let parts = [before, after]; // enter replaces middle selection.
    cursor = {index: 1, offset: 0};

    formats = [beforeFormats, afterFormats];
    if (step.level === StepLevel.HEADER) {
      levels = [StepLevel.HEADER, StepLevel.STEP];
    } else if (e.shiftKey) {
      levels =
        step.level === StepLevel.STEP ? [StepLevel.STEP, StepLevel.DESC] : [StepLevel.DESC, StepLevel.STEP]; // enter/exit desc mode.
    } else if (parts[0].length === parts[1].length && parts[1].length === 0) {
      levels = [levelUntab(step.level)]; // if empty, go up a level.
      formats = [formatters.defaultFormats()];
      parts = [''];
      cursor = {index: 0, offset: 0};
    } else {
      levels = [step.level, step.level]; // normal split
    }

    const firstLevel = levels.shift();
    const firstText = parts[0];
    const firstFormat = formats.shift();
    const restTexts = parts.slice(1);

    const newStep = reactUpdate(step, {
      $merge: {
        text: firstText,
        formats: firstFormat,
        level: firstLevel,
      },
    });

    const restSteps = (() => {
      const result = [];
      for (const [stepText, stepLevel, stepFormat] of Array.from(_.zip(restTexts, levels, formats))) {
        result.push(makeStep(stepText, stepFormat, stepLevel));
      }
      return result;
    })();

    const newSteps = reactUpdate(steps, {$splice: [[index, 1, newStep, ...Array.from(restSteps)]]});

    this.setSteps(newSteps);
    this.setState({insertIndex: cursor.index + index});
    const newCid = newSteps[cursor.index + index].cid;
    this.props.requestSelection({selection: {cid: newCid, start: cursor.offset, end: cursor.offset}});
  },

  moveHandler(index, e) {
    const {up, beginning} = e;

    const steps = this.getSteps();
    const step = steps[index];

    const dir = up ? -1 : 1;
    const targetStep = steps[index + dir];

    if (targetStep != null) {
      if (beginning) {
        this.props.requestSelection(this.selectionAtStart(targetStep));
      } else {
        this.props.requestSelection(this.selectionAtEnd(targetStep));
      }
    } else if (up) {
      this.clearSelection();
      const location = beginning ? 'start' : 'end';
      this.props.jumpTo({section: EditorKey.MATERIALS, location});
    } else if (this.props.getType(step) === StepLevel.TABLE && !this.props.locked) {
      this.insertItemHandler(index, StepLevel.STEP);
    }
  },

  tabHandler(index, e) {
    const {shiftKey, target} = e;

    const steps = this.getSteps();
    const step = steps[index];

    if (!Array.from(TABBABLE_LEVELS).includes(step.level)) {
      return;
    }

    const newLevel = shiftKey ? levelUntab(step.level) : levelTab(step.level);
    const newStep = reactUpdate(step, {$merge: {level: newLevel}});

    const ops = [[index, 1, newStep]];

    const newSteps = reactUpdate(steps, {$splice: ops});
    this.setSteps(newSteps);
    this.props.requestSelection({selection: selutil.getSelectionIndices(e)});
  },

  tabRangeHandler({start, end, shiftKey}) {
    let step;
    const steps = this.getSteps();

    const insert = shiftKey
      ? (() => {
          const result = [];
          for (step of Array.from(steps.slice(start, Number(end) + 1 || undefined))) {
            if (Array.from(TABBABLE_LEVELS).includes(step.level)) {
              result.push(reactUpdate(step, {$merge: {level: levelUntab(step.level)}}));
            } else {
              result.push(step);
            }
          }
          return result;
        })()
      : (() => {
          const result1 = [];
          for (step of Array.from(steps.slice(start, Number(end) + 1 || undefined))) {
            if (Array.from(TABBABLE_LEVELS).includes(step.level)) {
              result1.push(reactUpdate(step, {$merge: {level: levelTab(step.level)}}));
            } else {
              result1.push(step);
            }
          }
          return result1;
        })();
    const newSteps = reactUpdate(steps, {$splice: [[start, end - start + 1, ...Array.from(insert)]]});
    this.setSteps(newSteps);
  },

  openManageSelectorsModal(id) {
    return this.props.openManageSelectorsModal(id);
  },
});

export default StepsEditor;
